export class Coursetitle {
	public language: string;
	public title: string;
}
